/* VEXiAL — el único formateador de dinero del JS del tema.

   Antes cada sitio armaba el precio a mano y el mismo producto salía
   con cuatro formatos distintos según dónde lo miraras:

     header-vexial.js (buscador)   $52.00          -- sin moneda
     wishlist-vexial               $52.00 USD
     Articulo-vexial (x2)          $52.00 USD
     custom-product (del servidor) $.52.00 USD

   El del servidor sale raro porque el formato de moneda de la TIENDA
   está mal puesto en el admin: dice "<span class=money>$.{{amount}}
   USD</span>", con un punto de más. Eso no se arregla desde el tema —
   es un ajuste de tienda, lo hereda también el tema publicado y lo
   decide el dueño. Ver MONEDA-SOLES.md §6.5.

   Mientras tanto este helper NO hereda esa rareza: pinta el formato
   correcto, que resulta ser el que ya usaba la lista de deseos. El día
   que se arregle el ajuste, los dos formatos coinciden solos y no hay
   que tocar nada acá.

   Los soles siguen MONEDA.md: §3 (la fórmula, en enteros, idéntica a la
   de snippets/vx-money.liquid) y §3.4 (lo que se añade aquí). La tasa no
   se lee de ningún ajuste: llega de Liquid en window.VX_MONEDA, que
   publica snippets/vx-moneda-head.liquid. Así el HTML en caché y la tasa
   con la que se calcularon sus precios nunca se desincronizan.

   Ojo con los nombres: currency() es la moneda en la que COBRA la tienda
   —siempre USD—, no la que eligió el cliente para ver los precios. Esa
   es active(). No hay que confundirlas.

   Se carga con defer desde layout/theme.liquid, así que nada que corra
   durante el parseo puede llamarlo. Los scripts inline de las secciones
   solo lo usan dentro de manejadores de clic o después de
   DOMContentLoaded. */
(function () {
  'use strict';

  /* La moneda activa de la tienda. Hoy siempre USD; se lee en vez de
     cablearse para que el día que la tienda venda en otra cosa el
     sufijo no mienta. */
  function currency() {
    return (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
  }

  /* Centavos, que es como Shopify devuelve el dinero en /cart.js, en
     product.js y en las variantes. Las únicas fuentes decimales son
     /search/suggest.json y los data-vxc-price de las tarjetas; para
     esas está fromDecimal(). */
  function format(cents) {
    var n = Number(cents);
    if (!isFinite(n)) return '';
    return '$' + (n / 100).toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }) + ' ' + currency();
  }

  function fromDecimal(amount) {
    var n = parseFloat(amount);
    if (!isFinite(n)) return '';
    return format(Math.round(n * 100));
  }

  /* Decimales a centavos. Math.round y no un truncado: 34.1 * 100 da
     3409.999... en coma flotante. */
  function toCents(amount) {
    var n = parseFloat(amount);
    return isFinite(n) ? Math.round(n * 100) : 0;
  }

  /* ── Soles ─────────────────────────────────────────────────────── */

  /* La configuración validada por Liquid, o null si la moneda está
     apagada o la tasa no pasó el fallo seguro (MONEDA.md §2.3). */
  function config() {
    var c = window.VX_MONEDA;
    return c && c.activa ? c : null;
  }

  function enabled() {
    return config() !== null;
  }

  /* Centavos de dólar a céntimos de sol, redondeado hacia arriba al paso.
     Todo en enteros (MONEDA.md §3.2): a 3.75 y paso 0.50, el cálculo en
     coma flotante cobra medio sol de más en 66 precios entre $0 y $2,000.
     El precio más alto a la tasa más alta cabe de sobra en un entero
     seguro de JS. */
  function toPen(usdCents) {
    var c = config();
    if (!c) return null;
    var n = Number(usdCents);
    if (!isFinite(n) || n < 0) return null;
    n = Math.round(n);
    var div = 10000 * c.pasoC;
    var t = n * c.tasaBp + div - 1;
    return (t - t % div) / div * c.pasoC;
  }

  /* S/ con espacio de no separación y siempre dos decimales (MONEDA.md
     §1.1), sin sufijo PEN. */
  function formatPen(penCentimos) {
    var n = Number(penCentimos);
    if (!isFinite(n)) return '';
    return 'S/ ' + (n / 100).toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  /* La moneda en la que el cliente está viendo los precios. */
  function active() {
    return enabled() && document.documentElement.getAttribute('data-vx-moneda') === 'pen' ? 'pen' : 'usd';
  }

  /* El precio en la moneda activa, como texto. Para lo que no puede llevar
     marcado, como un mensaje. penCentimos es el sol fijado a mano, si lo
     hay; si no, se convierte. */
  function formatActive(usdCents, penCentimos) {
    if (active() === 'pen') {
      var p = penCentimos != null && penCentimos >= 0 ? penCentimos : toPen(usdCents);
      if (p != null) return formatPen(p);
    }
    return format(usdCents);
  }

  /* El mismo marcado que emite snippets/vx-money.liquid (MONEDA.md §6.1),
     para lo que se pinta en el navegador. Apagado devuelve solo el texto
     en dólares, igual que antes de la moneda.

     opts.usd     el texto en dólares, si ya viene formateado
     opts.pen     céntimos fijados a mano; -1 = a mano pero sin sol (un
                  tachado vacío), que se ve solo en dólares
     opts.fuente  variante | producto | conversion
     opts.aprox   antepone "≈": donde el sol puede no ser el definitivo
                  porque la superficie no lee metafields (MONEDA.md §5) */
  function html(usdCents, opts) {
    opts = opts || {};
    var usd = opts.usd != null ? String(opts.usd) : format(usdCents);
    if (!enabled()) return usd;
    var n = Math.round(Number(usdCents)) || 0;
    var pen = opts.pen != null ? Number(opts.pen) : toPen(n);
    if (pen == null || !isFinite(pen) || pen < 0) {
      return '<span class="vx-money vx-money--solo-usd" data-usd-cents="' + n + '">'
        + '<span class="vx-money--usd">' + usd + '</span></span>';
    }
    var fuente = opts.fuente || (opts.pen != null ? 'variante' : 'conversion');
    return '<span class="vx-money" data-usd-cents="' + n + '" data-pen-centimos="' + pen + '" data-pen-fuente="' + fuente + '">'
      + '<span class="vx-money--usd">' + usd + '</span>'
      + '<span class="vx-money--pen">' + (opts.aprox ? '≈ ' : '') + formatPen(pen) + '</span></span>';
  }

  /* El porcentaje de descuento (MONEDA.md §4.3), con el mismo marcado que
     el modo descuento de snippets/vx-money.liquid. Se calcula en dólares y
     es el mismo en las dos monedas, salvo que precio y tachado en soles
     estén fijados a mano. Sin descuento devuelve ''.

     opts.pen         céntimos del precio en soles
     opts.penCompare  céntimos del tachado en soles; -1 = a mano pero vacío
     opts.fuente      variante | producto | conversion */
  function discountHtml(priceCents, compareCents, opts) {
    opts = opts || {};
    var p = Math.round(Number(priceCents)) || 0;
    var c = Math.round(Number(compareCents)) || 0;
    if (!(c > p)) return '';
    var pct = Math.round((c - p) * 100 / c);
    var txt = '-' + pct + '%';
    if (!enabled()) return txt;
    var pctPen = -1;
    if (!opts.fuente || opts.fuente === 'conversion') {
      pctPen = pct;
    } else if (Number(opts.penCompare) > Number(opts.pen)) {
      pctPen = Math.round((opts.penCompare - opts.pen) * 100 / opts.penCompare);
    }
    if (pctPen === pct) return txt;
    if (pctPen < 0) {
      return '<span class="vx-money vx-money--solo-usd"><span class="vx-money--usd">' + txt + '</span></span>';
    }
    return '<span class="vx-money"><span class="vx-money--usd">' + txt + '</span>'
      + '<span class="vx-money--pen">-' + pctPen + '%</span></span>';
  }

  window.VXMoney = {
    format: format,
    fromDecimal: fromDecimal,
    toCents: toCents,
    currency: currency,
    enabled: enabled,
    toPen: toPen,
    formatPen: formatPen,
    active: active,
    formatActive: formatActive,
    html: html,
    discountHtml: discountHtml
  };
})();
